module.exports = __webpack_public_path__ + "static/media/email.82189696.svg";